import CityPage from "@/components/feature/CityPage";

const data = {
  cityName: "Burnsville",
  stateName: "Minnesota",
  stateAbbr: "MN",
  stateRoute: "/minnesota",
  heroImageQuery:
    "Aerial view of Burnsville Minnesota south metro suburban cityscape with Heart of the City retail district, Crystal Lake waterfront, suburban neighborhoods and green parks, Dakota County landscape, warm golden hour lighting, clean professional photography, no readable text or signs",
  heroImageSeq: "burnsville-mn-hero",
  heroDescription:
    "Business trip to Europe in two weeks? Family vacation to Mexico and your passport just expired? Need a first-time passport before starting a new job with international travel? We help Burnsville residents — from the Heart of the City area to Crystal Lake families — get their passports fast. As a registered U.S. Department of State courier — not a reseller — we offer a best price guarantee and rates typically 30–100% lower than FedEx, Staples, and other passport courier resellers. As fast as 24 hours. A+ BBB rated. No office visit required.",
  geoPosition: "44.7677; -93.2777",
  geoPlacename: "Burnsville, Minnesota",
  geoRegion: "US-MN",
  canonicalUrl: "https://fastpassportcenter.com/burnsville/",
  localAreaTitle: "Serving Burnsville & South Metro Dakota County",
  localAreaText: [
    "Burnsville, Minnesota is one of the most recognizable communities in the Twin Cities south metro, defined by the iconic Heart of the City mixed-use district, the Black Dog Road commercial corridor, and the natural beauty of Crystal Lake. Located in Dakota County at the intersection of I-35W and Highway 13, Burnsville sits at the geographic center of the south metro's residential and commercial activity. Major employers including Burnsville Center area businesses, healthcare organizations, and technology companies employ thousands of professionals who travel internationally.",
    "The south metro's access to MSP Airport — less than fifteen minutes via I-35W — creates a unique passport urgency environment in Burnsville. Business travelers at South Robert Street offices and the Nicollet Avenue commercial district regularly book international trips with short notice. A healthcare manager needs to fly to a conference in Dublin. A marketing professional at a Burnsville agency gets assigned to client meetings in Amsterdam. A construction company executive needs a passport renewed before a project site visit in Canada. Standard government processing is too slow for any of these situations.",
    "Family travel is equally active in Burnsville. The community's family-oriented neighborhoods, strong schools, and Crystal Lake Recreation Area generate significant leisure travel — spring break trips to Cancun, Caribbean cruises, and European summer vacations. Fast Passport Center serves Burnsville's professional and family travel needs with dedicated agents, expert document review, and processing as fast as 24 hours. Start online, ship overnight from anywhere in the south metro, and we handle the rest — no local office visit required.",
  ],
  nearbyCities: [
    { name: "Burnsville", zips: "55306, 55337" },
    { name: "Eagan", zips: "55121, 55122, 55123" },
    { name: "Apple Valley", zips: "55124" },
    { name: "Lakeville", zips: "55044" },
    { name: "Savage", zips: "55378" },
    { name: "Prior Lake", zips: "55372" },
  ],
  benefits: [
    {
      icon: "ri-computer-line",
      title: "Start 100% Online",
      desc: "No office visit required. Complete your order from your Burnsville home or office in minutes.",
    },
    {
      icon: "ri-truck-line",
      title: "Ship Your Documents",
      desc: "Use overnight shipping from any south metro UPS/FedEx. We handle the rest.",
    },
    {
      icon: "ri-shield-check-line",
      title: "Expert Document Review",
      desc: "Every application reviewed before submission — errors caught before they cost you a trip.",
    },
    {
      icon: "ri-calendar-check-line",
      title: "Reserved Agency Access",
      desc: "We hold reserved passport agency submission slots — no public appointment hunt required.",
    },
  ],
  serviceAreaTitle: "Burnsville & South Metro Coverage",
  serviceAreaDescription: "Serving Burnsville and Dakota County south metro communities",
  faqs: [
    {
      q: "How fast can I get a passport in Burnsville, MN?",
      a: "Through Fast Passport Center, expedited processing can be as fast as 24 hours for emergencies. Standard government processing through a Burnsville post office typically takes 2–6 months during busy season. For business travelers and families with upcoming trips, that timeline is not viable.",
    },
    {
      q: "Is the Burnsville Post Office an acceptance facility?",
      a: "Yes — the Burnsville Post Office at Burnsville Center area accepts passport applications by appointment for first-time applicants and minors who require an in-person acceptance clerk visit. For passport renewals, most Burnsville residents can ship directly to Fast Passport Center without any in-person visit.",
    },
    {
      q: "What if I have a cruise or international flight from MSP in two weeks?",
      a: "This is exactly when Fast Passport Center is most valuable. Start your order today, ship your documents overnight, and select the processing speed that matches your timeline. Our 2–9 business day option covers most upcoming trips. Emergency 24-hour processing is available for the most urgent departures.",
    },
    {
      q: "Can I expedite a child's passport from Burnsville?",
      a: "Yes — child passports require an in-person acceptance clerk visit with both parents or appropriate consent forms. We guide Burnsville families through the exact process, which local facility to use, and what documents to bring so the passport is ready before your family trip departs.",
    },
    {
      q: "Do I need to come to an office to use Fast Passport Center?",
      a: "No — most Burnsville travelers start online and ship overnight. There is no local office. Start your order online, use our personalized checklist, and ship your documents from the nearest UPS, FedEx, or post office.",
    },
    {
      q: "What documents do I need for an expedited passport renewal?",
      a: "For most renewals: your most recent passport, a DS-82 form, two 2x2 passport photos, and payment. We send a full personalized checklist after you start your order and review every document before submission to prevent errors.",
    },
  ],
  testimonials: [
    {
      name: "Tom B.",
      location: "Burnsville, MN",
      rating: 5,
      text: "I had a corporate trip to Amsterdam in nine days and realized my passport was expired. Fast Passport Center reviewed my paperwork, processed my renewal, and I had my passport in four business days. Made the trip, closed the deal. Their service is worth every penny.",
      service: "Passport Renewal",
    },
    {
      name: "The Johnson Family",
      location: "Crystal Lake Area, Burnsville",
      rating: 5,
      text: "We booked a Caribbean cruise last minute and found out our youngest needed a passport renewal — her childhood passport had expired. Fast Passport Center guided us through the process, reviewed our documents, and had her passport back in seven business days. We sailed on schedule.",
      service: "Child Passport",
    },
    {
      name: "Karen T.",
      location: "Heart of the City, Burnsville",
      rating: 5,
      text: "I accepted a new job requiring international travel and needed my passport renewed before my first trip. Fast Passport Center had my renewal back in five business days. Professional, organized, and the document review caught a form issue that would have caused a rejection. Highly recommend.",
      service: "Passport Renewal",
    },
  ],
  nearbyLinks: [
    { name: "Minneapolis", href: "/minneapolis" },
    { name: "Eagan", href: "/eagan" },
    { name: "Bloomington", href: "/bloomington" },
    { name: "Lakeville", href: "/lakeville" },
    { name: "Apple Valley", href: "/minnesota" },
    { name: "Woodbury", href: "/woodbury" },
  ],
  introTitle: "Emergency & Expedited Passport Services in Burnsville",
  introDescription: "Fast, reliable passport processing for Burnsville and south metro Dakota County travelers.",
  localResourcesIntro:
    "Getting your passport ready involves more than the application. Here are Burnsville and south metro resources to help you gather everything needed before your next international trip.",
  acceptanceFacilities: [
    {
      name: "Burnsville Post Office",
      address: "12 Burnsville Center, Burnsville, MN 55306",
      hours: "Mon–Fri 9:00 AM – 4:00 PM (appointment required)",
      phone: "(952) 890-2610",
      notes: "Primary passport acceptance facility for Burnsville. Appointment required. Passport photos available on-site.",
    },
    {
      name: "Eagan Post Office",
      address: "1280 Yankee Doodle Rd, Eagan, MN 55121",
      hours: "Mon–Fri 9:00 AM – 4:00 PM",
      phone: "(651) 688-6400",
      notes: "North Burnsville residents can use Eagan as an alternative. Call ahead for appointments.",
    },
    {
      name: "Apple Valley Post Office",
      address: "14700 Cedar Ave, Apple Valley, MN 55124",
      hours: "Mon–Fri 9:00 AM – 4:00 PM",
      phone: "(952) 432-6120",
      notes: "Southeast Burnsville alternative. Appointment recommended.",
    },
    {
      name: "Lakeville Post Office",
      address: "20575 Kenrick Ave, Lakeville, MN 55044",
      hours: "Mon–Fri 9:00 AM – 4:00 PM",
      phone: "(952) 469-5491",
      notes: "South Burnsville and Lakeville residents. Passport photos available.",
    },
  ],
  photoLocations: [
    { name: "CVS Pharmacy — Burnsville", address: "14601 Grand Ave S, Burnsville, MN 55306", hours: "Daily 7 AM – 10 PM" },
    { name: "Walgreens — Burnsville", address: "12541 Nicollet Ave S, Burnsville, MN 55337", hours: "Call for hours" },
    { name: "The UPS Store — Burnsville", address: "1380 Garden View Dr, Burnsville, MN 55337", hours: "Call for hours" },
    { name: "Target — Burnsville", address: "14200 Burnhaven Dr, Burnsville, MN 55306", hours: "Daily 8 AM – 10 PM" },
    { name: "Walgreens — Eagan", address: "3390 Courthouse Ln, Eagan, MN 55121", hours: "Call for hours" },
    { name: "CVS Pharmacy — Apple Valley", address: "15025 Glazier Ave, Apple Valley, MN 55124", hours: "Daily 7 AM – 10 PM" },
  ],
  dmvLocations: [
    {
      name: "Dakota County Driver and Vehicle Services — Burnsville",
      address: "Burnsville area service center, Dakota County",
      hours: "Mon–Fri, 8:00 AM – 4:30 PM",
      note: "Driver licenses, REAL ID, titles & registration. Appointment required — online scheduling available.",
      featured: true,
    },
    {
      name: "Dakota County Service Center — Hastings",
      address: "Hastings, MN 55033",
      hours: "Mon–Fri, 8:00 AM – 4:30 PM",
      note: "Secondary option for east Burnsville residents near the Dakota County border.",
      featured: false,
    },
  ],
  airports: [
    {
      code: "MSP",
      name: "Minneapolis-Saint Paul International Airport",
      distance: "About 8 miles from Burnsville — 12 minutes via I-35W",
      address: "4300 Glumack Drive, St. Paul, MN 55111",
      note: "Burnsville's direct I-35W access makes MSP one of the most convenient airports in the south metro. Nonstop international service to Amsterdam, London, Paris, Tokyo, and Reykjavik.",
      flightUrl: "https://www.mspairport.com/",
      flightLabel: "MSP Airport Website",
      featured: true,
    },
    {
      code: "ANE",
      name: "Anoka County–Blaine Airport",
      distance: "Blaine, MN — north metro, about 35 miles",
      address: "1 Anoka County Airport, Blaine, MN 55449",
      note: "General aviation airport. Not a commercial international option. Most Burnsville travelers use MSP for all international departures.",
      flightUrl: "https://www.anokacounty.us/1350/Airport",
      flightLabel: "Anoka County Airport",
      featured: false,
    },
  ],
  travelCards: [
    {
      title: "I-35W to MSP — One of the Fastest Routes in the South Metro",
      subtitle: "Burnsville's direct highway access to international departures",
      content:
        "Burnsville's I-35W corridor provides one of the most direct routes to MSP Airport in the south metro — approximately 10–15 minutes in normal traffic. This proximity means Burnsville residents are frequent MSP international travelers, and when a passport issue is discovered before departure, the resolution window is measured in days, not weeks.",
      tip: "Burnsville's direct I-35W connection to MSP means business travelers can book international flights with minimal lead time. Always check passport expiration before purchasing non-refundable international tickets.",
      icon: "ri-flight-takeoff-line",
    },
    {
      title: "South Metro Business Travel",
      subtitle: "Burnsville's commercial and healthcare employment base",
      content:
        "Burnsville's employers in healthcare, retail management, technology services, and construction regularly send employees on international assignments. These trips arrive with variable lead times — sometimes 3 weeks for planned conferences, sometimes 5 days for emergency client visits. Standard passport processing simply cannot accommodate these timelines.",
      tip: "If your employer regularly sends you on international business, maintain your passport with at least 18 months remaining validity to avoid last-minute rushes.",
      icon: "ri-briefcase-4-line",
    },
    {
      title: "Family Travel from Burnsville",
      subtitle: "Cruises, resorts, and spring break from the Heart of the City",
      content:
        "Burnsville families are active international travelers — Caribbean cruises, Cancun resort vacations, and European summer tours are common. The challenge for many Burnsville families is that children's passports expire after 5 years, and parents frequently discover expiration issues only after booking non-refundable travel with compressed timelines.",
      tip: "Every family should do a passport check in September before spring break planning begins. Renewing early is far cheaper and less stressful than expedited emergency processing.",
      icon: "ri-parent-line",
    },
    {
      title: "Crystal Lake & Minnesota Outdoors",
      subtitle: "Fishing, hunting, and cabin travel across borders",
      content:
        "Many Burnsville residents maintain cabins and travel to fishing and hunting destinations in Ontario, Canada and northern Minnesota. All international travel — including border crossings to Canada — requires a valid passport for adults and children. Summer season surprises are common: passports that worked for a 2019 Canada fishing trip may have expired by 2024.",
      tip: "Check passports before booking Canadian fishing or hunting trips. Even quick day trips across the border by air require a valid passport for all travelers.",
      icon: "ri-water-flash-line",
    },
  ],
  destinations: [
    {
      name: "Caribbean",
      context: "Family cruises, Cancun resorts, and spring break packages from MSP",
      urgency: "Last-minute cruise deals compress the booking-to-departure window significantly",
      icon: "ri-map-pin-2-line",
    },
    {
      name: "United Kingdom",
      context: "Business meetings, technology conferences, and direct MSP to London flights",
      urgency: "Corporate travel typically has 7–21 days notice from Burnsville employers",
      icon: "ri-map-pin-2-line",
    },
    {
      name: "Netherlands",
      context: "MSP direct to Amsterdam, European tour connections, and heritage travel",
      urgency: "Direct Amsterdam flights make short-notice European travel increasingly common",
      icon: "ri-map-pin-2-line",
    },
    {
      name: "Mexico",
      context: "Cancun vacations, Puerto Vallarta resorts, and family spring break trips",
      urgency: "March-April spring break creates peak passport urgency for Burnsville families",
      icon: "ri-map-pin-2-line",
    },
    {
      name: "Canada",
      context: "Ontario fishing trips, Toronto business, and summer cabin travel",
      urgency: "Summer travel peak May–September, with hunting season October–November",
      icon: "ri-map-pin-2-line",
    },
    {
      name: "Germany",
      context: "Business conferences, Frankfurt connections, and Oktoberfest heritage tourism",
      urgency: "Fall conference season creates a second peak in August–September",
      icon: "ri-map-pin-2-line",
    },
  ],
  stats: [
    {
      stat: "8 Miles",
      label: "Burnsville to MSP Airport — direct I-35W access makes international travel highly accessible",
    },
    {
      stat: "55%",
      label: "of Burnsville expedited requests involve travel within 3 weeks of the order date",
    },
    {
      stat: "Mar–Aug",
      label: "peak season for Burnsville passport urgencies — spring break through summer vacation",
    },
    {
      stat: "24 Hours",
      label: "fastest emergency turnaround for a Burnsville traveler with a same-week international departure",
    },
  ],
};

export default function BurnsvillePage() {
  return <CityPage data={data} />;
}